export const toastIgnore = [
    "/news/v1/news-like",
    "/news/v1/news-dislike",
    "/signal/v1/signal-like",
    "/signal/v1/signal-dislike",
    "/user/v1/send-otp",
    "/user/v1/submit-otp",
    "/file/v1/upload",
]